export default "__VITE_ASSET___app/immutable/assets/default-avatar-5.CZOPqU50.svg__"